import React from "react";
import { Sidebar } from "primereact/sidebar";
import { Button } from "primereact/button";
import { MenuConstants } from "../../../../constants";

import EdexLogo from "../../../../assets/images/Ed_EX_logo_plain.png";
import {
  changeNavigation,
  toggleSideBar,
} from "../../../../store/slices/navigationSlice";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

function MobileSidebar({
  enterprise,
  dashboard,
  changeNavigation,
  user,
  navigation,
  toggleSidebar,
  isSidebarOpen,
}) {
  const intl = useIntl();
  const navigate = useNavigate();

  let logo = EdexLogo;
  if (enterprise && enterprise.logo) {
    logo = enterprise.logo;
  }

  const { role } = user || {};

  const navigateToMenu = (menu) => {
    const childMenu = menu.childrens?.find((child) => child.index);
    const subChildMenu = childMenu?.childrens?.find((child) => child.index);

    const payload = {
      parent: menu.id,
      child: null,
      action: null,
    };

    if (!subChildMenu && childMenu) {
      payload.action = childMenu.id;
    } else if (subChildMenu) {
      payload.action = subChildMenu.id;
      payload.child = childMenu.id;
    }
    changeNavigation({ ...payload });
    navigate(subChildMenu?.to || childMenu?.to || menu.to);
  };

  let menus = MenuConstants.ADMIN_MENU_ITEMS;
  if (enterprise && enterprise?.logo && dashboard === "admin") {
    menus = MenuConstants.ENTERPRISE_ADMIN_MENU_ITEMS;
  } else if (enterprise && enterprise?.logo && dashboard === "learner") {
    const { learnerSettings = {} } = enterprise?.learningConfiguration || {};
    const { customLabels, defaultDashboard } = learnerSettings;
    menus = MenuConstants.LEARNER_MENU_ITEMS;
    menus = menus.map((menu) => {
      if (menu.id === MenuConstants.LEARNING_JOURNEY) {
        menu.label = customLabels?.learningJourney || menu.label;
        if (customLabels?.learningJourney) {
          menu.customised = true;
        }
        if (defaultDashboard === MenuConstants.LEARNING_DASHBORD) {
          menu.index = true;
        } else {
          menu.index = false;
        }
      } else if (menu.id === MenuConstants.DASHBOARD) {
        menu.label = customLabels?.dashboard || menu.label;
        if (customLabels?.dashboard) {
          menu.customised = true;
        }
        if (!defaultDashboard || defaultDashboard === MenuConstants.DASHBOARD) {
          menu.index = true;
        } else {
          menu.index = false;
        }
      }
      return menu;
    });
  }

  return (
    <div className="card flex justify-content-center">
      <Sidebar
        visible={isSidebarOpen}
        onHide={toggleSidebar}
        content={({ closeIconRef, hide }) => (
          <div className="min-h-screen flex relative lg:static surface-ground">
            <div
              id="app-sidebar-2"
              className="surface-section h-screen block flex-shrink-0 absolute lg:static left-0 top-0 z-1 border-right-1 surface-border select-none"
              style={{ width: "280px" }}
            >
              <div className="flex flex-column h-full">
                <div className="flex align-items-center justify-content-between flex-shrink-0">
                  <div className=" edexlms-header flex">
                    <div className="edexlms-header-logo w-full">
                      {((!enterprise || !enterprise.logo) && (
                        <img src={EdexLogo} alt="Logo" className="logo" />
                      )) || (
                        <img
                          src={`${new URL(
                            logo,
                            process.env.REACT_APP_URL
                          ).toString()}`}
                          alt="Logo"
                          className="logo"
                        />
                      )}
                    </div>
                    <span className="flex m-auto">
                      <Button
                        type="button"
                        ref={closeIconRef}
                        onClick={(e) => hide(e)}
                        icon="pi pi-times"
                        rounded
                        outlined
                        className="h-2rem w-2rem"
                      ></Button>
                    </span>
                  </div>
                </div>
                <div className=" edexlms-side-bar w-full">
                  <ul className="edexlms-side-bar-list">
                    {menus
                      .filter((item) => {
                        if (item.scope) {
                          return (
                            item.scope.filter((scope) => role?.scope?.[scope])
                              .length > 0
                          );
                        }
                        if (item.conditions) {
                          const isAllowed = Object.keys(item.conditions).reduce(
                            (acc, condition) => {
                              return (
                                user?.[condition] ===
                                  item.conditions[condition] && acc
                              );
                            },
                            true
                          );
                          return isAllowed;
                        }
                        return true;
                      })
                      .map((item, index) => {
                        return (
                          <li
                            key={index}
                            onClick={(e) => {
                              e.stopPropagation();
                              navigateToMenu(item);
                            }}
                            className={
                              navigation?.parent === item.id ? "active" : ""
                            }
                          >
                            <span className={item.icon} />
                            <span className="edexlms-side-bar-menu-label">
                              {item.customised
                                ? item.label
                                : intl.formatMessage({ id: item.label })}
                            </span>
                          </li>
                        );
                      })}
                  </ul>
                  <li className="footer">
                    <div className="powered-by">
                      <img
                        src={EdexLogo}
                        alt="Powered By"
                        className="powered-by-logo"
                      />
                    </div>
                  </li>
                </div>
              </div>
            </div>
          </div>
        )}
      ></Sidebar>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state?.self?.user,
  enterprise: state?.global?.enterprise,
  dashboard: state?.self?.dashboard,
  navigation: state?.navigation,
  isSidebarOpen: state?.navigation?.isSideBarOpen,
});

const mapDispatchToProps = (dispatch) => ({
  changeNavigation: (navigation) => dispatch(changeNavigation(navigation)),
  toggleSidebar: () => dispatch(toggleSideBar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileSidebar);
